import React from 'react';

function IconDarkTheme() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <path
        fillRule="evenodd"
        d="M9.154.628a.75.75 0 01-.065.84 6.678 6.678 0 00-1.476 4.188c0 3.761 3.144 6.846 7.067 6.846a7.228 7.228 0 003.009-.649.75.75 0 011.008.96c-1.386 3.482-4.856 5.937-8.903 5.937-5.25 0-9.544-4.142-9.544-9.296C.25 4.766 3.804.914 8.397.258a.75.75 0 01.757.37zM6.888 2.182C3.873 3.314 1.75 6.154 1.75 9.454c0 4.286 3.581 7.796 8.044 7.796 2.779 0 5.22-1.364 6.665-3.428a8.82 8.82 0 01-1.779.18c-4.71 0-8.567-3.716-8.567-8.346 0-1.24.278-2.416.775-3.474z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconDarkTheme;
